import { connect } from 'react-redux'
import AppComponent from '../components/App'
import $ from 'jquery';

const mapStateToProps = state => {
  // Every time mapObject changes, save it to the DOM
  $('#wp_mapbox_gl_js_map_object').val(JSON.stringify(state.mapObject));
  return {
    mapObject : state.mapObject,
    mapActions : state.mapActions
  }
}

const App = connect(
  mapStateToProps
)(AppComponent)

export default App



// WEBPACK FOOTER //
// ./src/containers/App.js